export default __webpack_public_path__ + "static/media/takeassessment.03ba993f.jpg";